import React from "react";
import { useI18n } from "../i18n/I18nContext";
import SectionHead from "../components/SectionHead";

export default function Footer({ onOpenSources }) {
  const { t } = useI18n();
  return (
    <footer
      id="colophon"
      className="border-t hair pt-20 pb-12"
      data-testid="footer-section"
    >
      <div className="container-edge">
        <SectionHead
          kana={t.sections.colophon.kana}
          roman={t.sections.colophon.roman}
        />

        <div className="grid grid-cols-12 gap-y-10 md:gap-x-10">
          {/* definition */}
          <div className="col-span-12 md:col-span-6">
            <p className="mono mb-4" style={{ color: "var(--faded)" }}>
              the definition
            </p>
            <p
              className="text-[16px] md:text-[19px] leading-[1.5]"
              style={{ color: "var(--ink)", fontWeight: 300, maxWidth: "46ch" }}
              data-testid="footer-definition"
            >
              {t.colophon.definition}
            </p>
          </div>

          {/* attribution + links */}
          <div className="col-span-12 md:col-span-3 md:col-start-8">
            <p className="mono mb-4" style={{ color: "var(--faded)" }}>
              attribution
            </p>
            <p
              className="body-text mb-8"
              data-testid="footer-attribution"
              style={{ maxWidth: "36ch" }}
            >
              {t.colophon.attribution}
            </p>
            <button
              type="button"
              onClick={onOpenSources}
              className="mono under-link"
              style={{ color: "var(--ink)" }}
              data-testid="footer-sources-btn"
            >
              {t.literature.seeAll}  →
            </button>
          </div>

          <div className="col-span-12 md:col-span-2 md:col-start-11">
            <p className="mono mb-4" style={{ color: "var(--faded)" }}>
              elsewhere
            </p>
            <ul className="space-y-2 mono-md" style={{ color: "var(--ink)" }}>
              <li>
                <a
                  href="https://www.xn--stto-l3a.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="under-link"
                  data-testid="footer-sotto-link"
                >
                  sōtto  ↗
                </a>
              </li>
              <li>
                <a href="#practice" className="under-link">
                  the practice
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* bottom spine */}
        <div className="border-t hair mt-16 pt-6 grid grid-cols-12 gap-4">
          <p
            className="col-span-12 md:col-span-8 mono"
            style={{ color: "var(--faded)", lineHeight: 1.55 }}
            data-testid="footer-disclaimer"
          >
            {t.colophon.disclaimer}
          </p>
          <div className="col-span-12 md:col-span-4 md:text-right flex md:justify-end gap-6 mono" style={{ color: "var(--faded)" }}>
            <span>              {t.colophon.copy}  /  {new Date().getFullYear()}</span>
            <span>{t.colophon.printedIn}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
